import { Chart, ChartType } from 'chart.js';
import { PolygonController, PolylineController, MarkerController, MapController } from './controllers';
import { MapPlugin } from './plugins';
import { MapChartDataset, MapChartOptions } from "./types";
import { PolygonElement, PolylineElement, MarkerElement } from './elements';
import 'maplibre-gl/dist/maplibre-gl.css';
import './style.css';

declare module 'chart.js' {
    interface ChartTypeRegistry {
        map: {
            type: 'polygon' | 'line' | 'point';
            data: MapChartDataset[];
            options: MapChartOptions;
        };
    }
    interface MapPlugin<TType extends ChartType> {
        map?: {
            color?: string
        }
    }
}

// Do NOT call Chart.register(...) at module top-level. Under bundlers with strict
// module-eval ordering (Turbopack / Next.js) a top-level register can run before
// chart.js has finished initialising its registries — it throws inside
// TypedRegistry.isForType and the whole module then resolves to an empty/undefined
// namespace, so every export is lost and map charts render blank. Consumers should
// register the pieces themselves, or call registerMapCharts() once on the client.
export function registerMapCharts() {
    Chart.register(MapController, PolygonController, MarkerController, PolylineController, PolylineElement, MarkerElement, PolygonElement);
}
export { MapController, MapPlugin, PolygonController, PolylineController, MarkerController, PolylineElement, MarkerElement, PolygonElement };
